import "./AboutSection.css";

const VALUES = [
	{
		title: "Mindfulness",
		desc: "Every design and sound decision honours calm awareness.",
		color: "#6B9E8D",
	},
	{
		title: "Quality",
		desc: "Produced and mastered at 432 Hz in the highest fidelity.",
		color: "#7EBBA3",
	},
	{
		title: "Accessibility",
		desc: "Wellness music should be available to everyone, everywhere.",
		color: "#8B7B9D",
	},
	{
		title: "Authenticity",
		desc: "Traditional Asian instruments and ancient techniques guide every piece.",
		color: "#C9A876",
	},
];

const AboutSection = () => (
	<section className="about-section">
		<div className="about-grid">
			<div>
				<span className="about-eyebrow">What is BodhiStreams?</span>
				<h2 className="about-heading">
					A streaming platform built for tranquility, harmony, and balance.
				</h2>
				<p className="about-lead">
					BodhiStreams is a mindful music streaming platform delivering
					original, high-quality 432 Hz wellness compositions for meditation,
					relaxation, and spiritual practice.
				</p>
				<p className="about-body">
					Every track is influenced by slow, meditative movements, ancient
					traditions, and relaxation techniques. A textural, ethnic presence
					created by traditional Asian instruments blends these pieces together
					— a calm space for meditation, relaxation, and devotional listening,
					designed to help you reach deeper levels of presence.
				</p>
			</div>
			<div className="about-values">
				{VALUES.map((value) => (
					<div
						key={value.title}
						className="about-value"
						style={{ "--value-color": value.color }}
					>
						<span className="about-value-dot" />
						<h3 className="about-value-title">{value.title}</h3>
						<p className="about-value-desc">{value.desc}</p>
					</div>
				))}
			</div>
		</div>
	</section>
);

export default AboutSection;
